import { useEffect } from 'react';

/**
 * @description
 * A callback that gets passed back the postmessage event object and an embedded flag.  Should respond to events
 * directly from this callback.
 * @callback PostMessageListener
 * @param {*} event the post message event
 * @param {boolean} isEmbedded whether or not the app is currently embedded in an iframe
 * @returns {void}
 */

/**
 * @description
 * it's better to respond to directly on the post message event. This call should
 * only be used to initiate communication from the app, not responding to a postmessage event
 * @callback PostMessageDispatcher
 * @param {*} postMessage the data to be sent to the parent origin.
 * @param {string} targetOrigin the parent origin.
 * @returns {void}
 */

/**
 * @todo Might need to pass allowed origin here explicitly
 * Make sure to only respond to known messages
 * @param {PostMessageListener} listener
 * @returns {PostMessageDispatcher}
 */
export const usePostMessage = (listener = (e) => e) => {
	useEffect(() => {
		window.addEventListener('message', listener);
		return () => {
			window.removeEventListener('message', listener);
		};
	}, [listener]);

	/**
	 * it's better to respond to directly on the post message event. This call should
	 * only be used to initiate communication from the app, not responding to a postmessage event
	 * */
	return (postMessage) => {
		window.parent.postMessage(postMessage, '*');
	};
};

/**
 * based on https://stackoverflow.com/a/326076
 * @returns {boolean}
 */
export const inIframe = () => {
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
};

export const getParentDomain = function() {
	return window.location !== window.parent.location
		? document.referrer
		: document.location.origin;
};
